export const accessRolesTranslation = {
  title: 'accessRoles.pageTitle',
  description: 'accessRoles.pageDescription',
  createButton: 'accessRoles.createButton',
  table: {
    title: 'accessRoles.table.title',
    noResults: 'accessRoles.table.noResults',
    statusActive: 'accessRoles.table.status.active',
    statusPending: 'accessRoles.table.status.pending',
    deleteProfile: 'accessRoles.table.actions.deleteProfile',
    editProfile: 'accessRoles.table.actions.editProfile',
    header: {
      name: 'accessRoles.table.header.name',
      email: 'accessRoles.table.header.email',
      number: 'accessRoles.table.header.number',
      status: 'accessRoles.table.header.status',
      profile: 'accessRoles.table.header.profile',
      actions: 'accessRoles.table.header.actions',
    },
  },
  modal: {
    title: 'accessRoles.modal.title',
    editTitle: 'accessRoles.modal.editTitle',
    desc: 'accessRoles.modal.desc',
    personalData: 'accessRoles.modal.personalData',
    nameAndSurnames: 'accessRoles.modal.nameAndSurnames',
    mail: 'accessRoles.modal.mail',
    useProfile: 'accessRoles.modal.useProfile',
    required: 'accessRoles.modal.required',
    master: {
      title: 'accessRoles.modal.master.title',
      descLine1: 'accessRoles.modal.master.desc.line1',
      descLine1_1: 'accessRoles.modal.master.desc.line1_1',
      descLine2: 'accessRoles.modal.master.desc.line2',
      descLine2_1: 'accessRoles.modal.master.desc.line2_1',
      descLine2_2: 'accessRoles.modal.master.desc.line2_2',
      descLine2_3: 'accessRoles.modal.master.desc.line2_3',
      descLine2_4: 'accessRoles.modal.master.desc.line2_4',
      descLine3: 'accessRoles.modal.master.desc.line3',
    },
    actions: {
      create: 'accessRoles.modal.actions.create',
      save: 'accessRoles.modal.actions.save',
      cancelar: 'accessRoles.modal.actions.cancelar',
    },
    successMessage: 'accessRoles.modal.createPerfil.successMessage',
    updateSuccessMessage: 'accessRoles.modal.createPerfil.updateSuccessMessage',
    resendWelcomeEmailSuccessMessage:
      'accessRoles.modal.resendWelcomeEmailSuccessMessage',
    errorMessage: 'accessRoles.modal.createPerfil.errorMessage',
    roleA: {
      downloads: 'accessRoles.modal.createPerfil.accessA.downloads',
      tpvs: 'accessRoles.modal.createPerfil.accessA.tpvs',
      searchVisor: 'accessRoles.modal.createPerfil.accessA.searchVisor',
      search1: 'accessRoles.modal.createPerfil.accessA.search1',
      search2: 'accessRoles.modal.createPerfil.accessA.search2',
      search3: 'accessRoles.modal.createPerfil.accessA.search3',
      create: 'accessRoles.modal.createPerfil.accessA.create',
    },
    roleB: {
      downloads: 'accessRoles.modal.createPerfil.accessB.downloads',
      tpvs: 'accessRoles.modal.createPerfil.accessB.tpvs',
      searchVisor: 'accessRoles.modal.createPerfil.accessB.searchVisor',
      search1: 'accessRoles.modal.createPerfil.accessB.search1',
      search2: 'accessRoles.modal.createPerfil.accessB.search2',
      search3: 'accessRoles.modal.createPerfil.accessB.search3',
      create: 'accessRoles.modal.createPerfil.accessB.create',
      contract1: 'accessRoles.modal.createPerfil.accessB.contract1',
      contract2: 'accessRoles.modal.createPerfil.accessB.contract2',
    },
    roleI: {
      downloads: 'accessRoles.modal.createPerfil.accessI.downloads',
    },
    roleGuarderia: {
      searchA: 'accessRoles.modal.createPerfil.guarderia.accessA.search',
      searchB: 'accessRoles.modal.createPerfil.guarderia.accessB.search',
      searchB2: 'accessRoles.modal.createPerfil.guarderia.accessB.search2',
      searchC: 'accessRoles.modal.createPerfil.guarderia.accessC.search',
      searchD: 'accessRoles.modal.createPerfil.guarderia.accessD.search',
      edit: 'accessRoles.modal.createPerfil.guarderia.accessB.edit',
    },
    form: {
      namelabel: 'accessRoles.modal.form.name.label',
      nameplaceHolder: 'accessRoles.modal.form.name.placeHolder',
      surname1label: 'accessRoles.modal.form.surname1.label',
      surname1placeHolder: 'accessRoles.modal.form.surname1.placeHolder',
      surname2label: 'accessRoles.modal.form.surname2.label',
      surname2placeHolder: 'accessRoles.modal.form.surname2.placeHolder',
      maillabel: 'accessRoles.modal.form.mail.label',
      mailplaceHolder: 'accessRoles.modal.form.mail.placeHolder',
    },
    delete: {
      title: 'accessRoles.modal.delete.title',
      desc: 'accessRoles.modal.delete.desc',
      cancel: 'accessRoles.modal.delete.cancel',
      delete: 'accessRoles.modal.delete.delete',
    },
    resendWelcomeEmail: {
      title: 'accessRoles.modal.resendWelcomeEmail.title',
      description: 'accessRoles.modal.resendWelcomeEmail.description',
    },
  },
}
